import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import ThreePillars from '../components/ThreePillars';
import SpecialsCarousel from '../components/SpecialsCarousel';
import { OrnateDivider, BananaLeaf, PalmTree } from '../components/KeralaDecor';
import ProductCard from '../components/ProductCard';
import ContactBlock from '../components/ContactBlock';
import products from '../data/products';
import menu from '../data/menu';
import site from '../data/site';
import './HomePage.css';

export default function HomePage() {
  const highlights = [
    menu[0].items[0], // Malabar Biriyani
    menu[1].items[0], // Fish Curry Kudampuli
    menu[2].items[0], // Chicken 65
    menu[3].items[0]  // Pazhampori
  ];
  const marketHighlights = products.slice(0, 4);

  return (
    <main className="home">
      <Hero />
      <ThreePillars />
      <SpecialsCarousel />

      {/* Our Story */}
      <section className="home-story">
        <PalmTree side="left" height={280} opacity={0.18} />
        <PalmTree side="right" height={280} opacity={0.18} />
        <div className="container home-story__inner">
          <span className="eyebrow-script">Our Story</span>
          <h2 className="home-story__title">Two Halves of One Kitchen</h2>
          <OrnateDivider />
          <div className="home-story__copy prose">
            <p>
              H2 Fresh started as a halal meat market: the kind of butcher counter where the
              cuts are honest and the sourcing is straight. We grew because our customers kept
              asking the same thing: <em>"Can you cook this for us, the way our grandmothers did
              back home?"</em>
            </p>
            <p>
              So we did. Today, H2 Fresh is both a Kerala restaurant and a Zabiha halal meat
              market: a place where the spice rack and the butcher block share a wall, where
              Malabar biriyani comes out of the same kitchen that hand-cut your weekend roast.
            </p>
            <p className="home-story__close"><strong>One family. One promise. Fresh from our hands to your table.</strong></p>
          </div>
          <ul className="home-story__pills">
            <li>Halal Certified</li>
            <li>Fresh Daily</li>
            <li>Family Owned</li>
          </ul>
        </div>
      </section>

      {/* Restaurant preview */}
      <section className="home-preview home-preview--menu">
        <BananaLeaf position="top-left" size={260} opacity={0.45} />
        <BananaLeaf position="bottom-right" size={260} opacity={0.45} mirror />
        <div className="container">
          <div className="home-preview__head">
            <span className="eyebrow-script">From the Kitchen</span>
            <h2>Tonight's Highlights</h2>
            <p>A taste of Malabar, one from each section of our menu.</p>
          </div>

          <div className="home-preview__grid">
            {highlights.map((item) => (
              <article key={item.name} className="home-highlight">
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                <span className="home-highlight__price">Call for pricing</span>
              </article>
            ))}
          </div>

          <div className="home-preview__cta">
            <Link to="/menu" className="btn btn-forest">See the Full Menu →</Link>
          </div>
        </div>
      </section>

      {/* Market preview */}
      <section className="home-preview home-preview--market">
        <div className="container">
          <div className="home-preview__head">
            <span className="eyebrow-script">From the Counter</span>
            <h2>The Halal Meat Market</h2>
            <p>Hand-cut, Zabiha, restocked all week. Walk in or call to order.</p>
          </div>

          <div className="home-market__grid">
            {marketHighlights.map((p) => (
              <ProductCard key={p.slug} product={p} />
            ))}
          </div>

          <div className="home-preview__cta">
            <Link to="/market" className="btn btn-gold">Browse the Market →</Link>
          </div>
        </div>
      </section>

      {/* Contact strip */}
      <section className="home-contact">
        <div className="container home-contact__inner">
          <div>
            <span className="eyebrow-script">Visit</span>
            <h2>{site.address.line1.replace('#', 'No. ')}</h2>
            <p className="home-contact__city">{site.address.line2}</p>
            <div className="home-contact__cta">
              <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-gold">Get Directions</a>
              <a href={`tel:${site.phones[0].tel}`} className="btn btn-ghost">📞 {site.phones[0].display}</a>
            </div>
          </div>
          <ContactBlock variant="dark" />
        </div>
      </section>
    </main>
  );
}
